import { persistGateComponent as PersistGate } from 'investira.react.lib';

export default PersistGate;
